import { useMutation, useQueryClient } from '@tanstack/react-query';
import { saveStartupProfile, type StartupProfileUpdatePayload } from '../../api/startup-profile.api';

/** Matches `startupProfileModule.queryKey` (kept local to avoid a circular import back to `../startup`). */
const startupProfileQueryKey = (entityId: string) => ['profile', 'startup', entityId];

export interface SaveStartupProfileOptions {
  /** Runs after the cache is updated - the section panel closes and toasts here. */
  onSaved?: () => void;
}

/**
 * Saves the startup profile (MYN-72) and refreshes the cache. The outcome
 * handler lives on the mutation, not the `.mutate()` call site (write-action
 * feedback rule); a failure is read off `error` by the open panel.
 */
export function useSaveStartupProfile(entityId: string, options: SaveStartupProfileOptions = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: StartupProfileUpdatePayload) => saveStartupProfile(entityId, payload),
    onSuccess: (data) => {
      queryClient.setQueryData(startupProfileQueryKey(entityId), data);
      options.onSaved?.();
    },
  });
}
